import withMarketPromoPage from '../../../hocs/withMarketPromoPage';

const defaultImageSrc = '/static/img/promo-young-adults-events-detroit.jpg';

const imageSrcByCitySlug: Record<string, string> = {
  cincinnati: '/static/img/young-adults-events-cincinnati.png',
  detroit: '/static/img/promo-young-adults-events-detroit.jpg',
  montreal: '/static/img/promo-young-adults-events-montreal.jpg',
};

export default withMarketPromoPage({
  pageName: 'Young Adults Events Page',
  titleKey: 'youngAdultsEvents',
  filters: {
    target_age_slug: ['all-ages', 'young-adults'],
  },
  getImageSrc: ({ hiddenQueryParams: { market_slug } }) => {
    const imageKey = Object.keys(imageSrcByCitySlug).find((key) => {
      if (Array.isArray(market_slug) && market_slug.includes(key)) return key;
      return false;
    });

    const imageSrc = imageSrcByCitySlug[imageKey as keyof typeof imageSrcByCitySlug];

    if (imageSrc) return imageSrc;
    return defaultImageSrc;
  },
  getPixelId: ({ hiddenQueryParams: { market_slug } }) => {
    if (Array.isArray(market_slug) && market_slug.includes('montreal')) return 556295522100499;
  },
});
